import React, { useEffect } from 'react';
import styled from 'styled-components';
import { BellOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Popover, FloatButton } from 'antd';

import { notArrayOrEmpty } from 'src/misc/Misc';
import useNotifications from 'src/hooks/useNotifications';

import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

const StyledWrapper = styled.div`
  //TODO: add animation
`;

const NotifcationsMenu = () => {
  //const { notifications } = useContext(NotificationsContext);
  const notificationsHook = useNotifications();

  useEffect(() => {
    //TODO: add animation
    const floatBtn = document.getElementById('notofocations-float-button');
    if (!floatBtn) return;
    if (floatBtn.classList.contains('animate-bounce')) return;
    floatBtn.classList.add('animate-bounce');
    setTimeout(() => {
      floatBtn.classList.remove('animate-bounce');
    }, 2300);
  }, [notificationsHook.notifications]);

  const getNotificationItem = (notification) => {
    return (
      <StyledWrapper>
        <div className='max-w-xs mt-4'>
          <div className='flex flex-row mb-1'>
            <div className='flex-initial flex flex-row items-center text-xs text-sky-500'>{dayjs(notification.createdAt).fromNow()}</div>
            <div className='flex-auto flex flex-row items-center justify-end'>
              <CloseCircleOutlined
                className='text-sm text-sky-500 cursor-pointer opacity-60 hover:opacity-100'
                onClick={() => {
                  notificationsHook.removeNotification(notification?.id);
                }}
              />
            </div>
          </div>

          <div className='text-sm font-semibold'>{notification.title}</div>
          <div className='text-sm font-light'>{notification.message}</div>
        </div>
      </StyledWrapper>
    );
  };

  const content = (
    <div className='max-h-[60vh] overflow-auto'>
      {notificationsHook.notifications.map((notification) => {
        return <div key={notification?.id}>{getNotificationItem(notification)}</div>;
      })}
    </div>
  );

  if (true === notArrayOrEmpty(notificationsHook.notifications)) return null;

  return (
    <StyledWrapper>
      <Popover
        content={content}
        title={
          <>
            <BellOutlined /> Notifications
          </>
        }
        trigger='click'
      >
        <FloatButton id='notofocations-float-button' type='primary' icon={<BellOutlined />} badge={{ count: notificationsHook.notifications.length }} />
      </Popover>
    </StyledWrapper>
  );
};

NotifcationsMenu.propTypes = {};

export default NotifcationsMenu;
